// extracted by mini-css-extract-plugin
module.exports = {"content":"ConfirmModal__content___1ENv0","heading":"ConfirmModal__heading___ZXKL2"};